<template>
  <div class="page fr">
    <CollectionsPage
      :data="this.data"
      :language="'french'"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import CollectionsPage from "../components/CollectionsPage.vue";

import { mapMutations } from "vuex";

export default {
  name: "Fr",
  components: { CollectionsPage },
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    this.selectedLanguageMutation("Fr");
  },
  methods: {
    ...mapMutations(["selectedLanguageMutation"]),
  },
};
</script>
